import React from 'react';
import PropTypes from 'prop-types';
import { SRLWrapper } from 'simple-react-lightbox';

const Lightbox = ({ images }) => {
  const options = {
    buttons: {
      showAutoplayButton: false,
      showDownloadButton: false,
      showThumbnailsButton: false,
    },
  };

  /**
   * Hides the next and prev button if only 1 image.
   * They should have done this for me by default...
   * Why must I be the one to preempt it?
   */
  if (images.length === 1) {
    options.buttons.showNextButton = false;
    options.buttons.showPrevButton = false;
  }

  return <SRLWrapper options={options} elements={images} />;
};

Lightbox.propTypes = {
  images: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Lightbox;
